var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-link"},[_c('a',{staticClass:"choice",on:{"click":function($event){return _vm.handleSelectLink()}}},[_c('span',{staticClass:"mr-5"},[_vm._v("绘制热区")]),_c('i',{staticClass:"el-icon-edit"})]),_c('HotZoneModal',{ref:"HotZoneModal",on:{"handleSubmit":_vm.onUpdate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }